export default __webpack_public_path__ + "static/headshot-7c012a92845bed138e26810615ea6553.png";